import { sendWebsocketMessage } from '../../../../../App';

export function removeSavedAlertTradePlanConfiguration({
  configurationName,
  key,
}) {
  const msg = {
    messageType: 'removeSavedAlertTradePlanConfiguration',
    configurationName,
    key,
  };
  sendWebsocketMessage(msg);
}
